<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Beam`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.0015 7.54145L22.2481 15.2265C22.5574 15.4584 22.9962 15.3957 23.2281 15.0865 23.4601 14.7772 23.3974 14.3384 23.0881 14.1065L12.5015 6.16645C12.2056 5.945 11.7981 5.94404 11.5015 6.16645L.914808 14.1065C.605528 14.3384.542847 14.7772.774806 15.0865 1.00677 15.3957 1.44553 15.4584 1.75481 15.2265L12.0015 7.54145zM1.9668 17.3328C1.9668 16.9462 2.2802 16.6328 2.6668 16.6328H21.3335C21.7201 16.6328 22.0335 16.9462 22.0335 17.3328 22.0335 17.7194 21.7201 18.0328 21.3335 18.0328H2.6668C2.2802 18.0328 1.9668 17.7194 1.9668 17.3328z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.30078 11.3328C5.30078 10.9462 5.61418 10.6328 6.00078 10.6328H18.0008C18.3874 10.6328 18.7008 10.9462 18.7008 11.3328C18.7008 11.7194 18.3874 12.0328 18.0008 12.0328H6.00078C5.61418 12.0328 5.30078 11.7194 5.30078 11.3328Z"/></svg>
</template>
<script>

export default {
  name: 'IconBeam',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
